@if (solutionSpace$ | async; as solutionSpace) {
<app-component-incidents
  [solutionSpace]="solutionSpace"
  [incidents$]="incidents$"
  [updateIncidentsReponse$]="updateIncidentsResponse$"
  (changeIncidentsFilter)="onChangeIncidentsFilter($event)"
  (changePagination)="onChangePagination($event)"
  (updateIncidents)="onUpdateIncidents($event)"
>
</app-component-incidents>
}
